import { observer } from "mobx-react";
import { getSurvey, answerSurvey } from "../../utils/request";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { message, Radio } from "antd";
import styles from "../../css/userSurvey.module.scss";
import { useNavigate } from "react-router";
import { LayoutContext } from "../auth";
import { useTranslation } from "react-i18next";
import { Input } from "antd";

function UserSurvey() {
  const [survey, setSurvey] = useState({});
  const [answers, setAnswers] = useState([]);
  const navigate = useNavigate();
  const { setHead } = useContext(LayoutContext);
  const { t } = useTranslation();
  const getSurveyData = useCallback(() => {
    getSurvey().then((res) => {
      setSurvey(res.data);
      setAnswers(
        res.data.surveyQuestions.map((k) => ({
          question: k.id,
          answer: null,
        }))
      );
    });
  }, []);

  useEffect(() => {
    getSurveyData();
    setHead({
      needMenu: false,
    });
  }, [setHead, getSurveyData]);
  const answeredLength = useMemo(
    () => answers.filter((k) => !!k.answer)?.length,
    [answers]
  );
  const btnText = useMemo(
    () => `${answeredLength}/${survey.surveyQuestions?.length} 提交`,
    [survey, answeredLength]
  );
  const isAllChose = useMemo(() => {
    return answeredLength === survey.surveyQuestions?.length;
  }, [survey, answeredLength]);

  function onChange(e, index) {
    setAnswers((pre) => {
      const answers = [...pre];
      answers[index].answer = e.target.value;
      return answers;
    });
  }

  function onSubmit() {
    answerSurvey(answers).then(() => {
      message.success(t('submitSuccess'));
      navigate("/user", { replace: true });
    });
  }

  const Options = [
    {
      id: 1,
      label: '非常不同意',
      value: 1,
    },
    {
      id: 2,
      label: '不同意',
      value: 2,
    },
    {
      id: 3,
      label: '中立',
      value: 3,
    },
    {
      id: 4,
      label: '同意',
      value: 4,
    },
    {
      id: 5,
      label: '非常同意',
      value: 5,
    },
  ]

  return (
    <div className={styles.page}>
      <div className={styles.pageWrap}>
        <div className={styles.pageTitle}>调查问卷</div>
        <div className={styles.surveyHint}>
          <div>以下的描述有多符合你的真实感受?</div>
          <div>请根据你的真实感受选择最符合的答案，答案没有对错之分。</div>
        </div>
        <div className={styles.questions}>
          {survey.surveyQuestions?.map((k, index) => {
            return k.type === 'radio' ? (
              <div className={styles.questionItem} key={index}>

                <p>
                  {index + 1}、{k.title}
                </p>

                <Radio.Group
                  onChange={(e) => onChange(e, index)}
                  value={answers[index]?.answer}
                >
                  {Options.map((op, i) => (
                    <Radio value={op.value} key={op.id}>
                      {i + 1}分（{op.label}）
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            ) : (
              <div className={styles.questionItem} key={index}>
                <p>
                  {index + 1}、{k.title}
                </p>
                <Input placeholder="请输入您的答案" onChange={(e) => onChange(e, index)} />
              </div>
            )
          })}
        </div>
        <div
          className={`${styles.submitBtn} ${isAllChose ? styles.enable : ""}`}
          onClick={onSubmit}
        >
          {btnText}
        </div>
      </div>
    </div>
  );
}
export default observer(UserSurvey);
